import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CandidateOutreachPageComponent } from './candidate-outreach-page.component';
import { FormsModule } from '@angular/forms';
import { JobProfileModule } from '../job-profile-page/job-profile/job-profile.module';
import { TabsModule, TooltipModule } from 'ngx-bootstrap';
import { AddEditCandidateContactOneModule } from 'src/app/shared/add-edit-candidate-contact-one/add-edit-candidate-contact-one.module';
import { CandidateAdditionalDetailsModule } from 'src/app/shared/candidate-additional-details/candidate-additional-details.module';
import { FeedbackExecutionComponentWrapper } from './feedback-execution.wrapper';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { CandidateCardIconsModule } from 'src/app/shared/candidate-card-icons/candidate-card-icons.module';

@NgModule({
  declarations: [CandidateOutreachPageComponent, FeedbackExecutionComponentWrapper],
  imports: [
    CommonModule,
    FormsModule,
    JobProfileModule,
    TabsModule.forRoot(),
    AddEditCandidateContactOneModule,
    CandidateAdditionalDetailsModule,
    PipesModule,
    CandidateCardIconsModule,
    TooltipModule.forRoot()
  ],
  exports: [CandidateOutreachPageComponent, FeedbackExecutionComponentWrapper],
  entryComponents: [CandidateOutreachPageComponent]
})
export class CandidateOutreachPageModule { }
